module.exports = __webpack_public_path__ + "img/question-solid.98ce42d9.svg";